module.exports = __webpack_public_path__ + "images/cloud_error38ed7a0ec341927267d38e36abf3ff3a.svg";